<template>
    <v-container grid-list-xl fluid>
        <v-layout>
            <v-flex>
                <h3 class="pr-3">{{ $t('menu.agents') }}</h3>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-progress-linear v-show="loading" :indeterminate="true"></v-progress-linear>
            <template v-for="(item) in items">
                <v-flex xs12 sm6 md4>
                    <v-card style="cursor: pointer;">
                        <v-card-title primary-title style="padding: 0;">
                            <v-flex xs3>
                                <v-icon x-large>person</v-icon>
                            </v-flex>
                            <v-flex xs6>
                                <div>
                                    <div class="font-weight-bold">{{item.name}}</div>
                                    <div>{{item.phone}}</div>
                                </div>
                            </v-flex>
                            <v-flex xs3 class="text-xs-right"
                                @click.prevent.stop="item.showMenu = true"
                            >
                                <v-menu v-model="item.showMenu" bottom left>
                                    <v-btn
                                      slot="activator"
                                      icon
                                    >
                                        <v-icon>more_vert</v-icon>
                                    </v-btn>

                                    <v-list>
                                        <v-list-tile
                                          v-for="(action, index) in actions"
                                          :key="index"
                                          @click=""
                                        >
                                            <v-list-tile-title>{{action}}</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </v-flex>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </template>
        </v-layout>
    </v-container>
</template>

<script>
  import RequestHandler from '~/utils/request-handler'
  import {UrlServices} from "~/utils/url-manager";
  import i18n from "~/i18n";
  export default {
    data () {
      return {
        loading: false,
        items: [
          {id: 1, name: 'Apple', phone: '11111111'},
          {id: 2, name: 'Banana', phone: '22222222'},
          {id: 3, name: 'Orange', phone: '33333333'}
        ],
        actions: [i18n.t('action.edit'), i18n.t('action.delete')],
      }
    },
    methods: {
      // getContacts(page = 1) {
      //   let me = this;
      //   me.loading = true;
      //   RequestHandler.Get(UrlServices.createUrl({'name': 'api_contact_list'}), {page: page}, {
      //     'success': function(data){
      //       console.log('root', this.$parent);
      //       if(page === 1){
      //         data.data.map(x => x.showMenu = false);
      //         me.items = data.data;
      //       } else {
      //
      //       }
      //       me.loading = false;
      //     }
      //   });
      // },
      editItem(item) {
        console.dir(item.id);
      }
    },
    mounted() {
      //this.getContacts();
    }
  }
</script>

<style scoped>

</style>